export const NOT_FOUND = {
  name: 'notFound',
};

export const DEFAULT_ROUTE_PATH = '/welcome/index';
export const DEFAULT_ROUTE_TITLE = '首页';

export const REDIRECT_ROUTE_PATH = '/redirect/to';
export const LOGIN_ROUTE_PATH = '/login';
